var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452 520",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c73b8",
    d: "M41 460L0 0h451l-41 460-185 52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#30a9dc",
    d: "M226 472l149-41 35-394H226"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ecedee",
    d: "M226 208H94l5 57h127zm0-114H84l5 56h137zm0 261l-124-33 7 60 117 32z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M226 265h69l-7 73-62 17v59l115-32 26-288H226v56h80l-6 58h-74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.93d0281b823eb4bd4df7e843db0938b5.svg";
export { ForwardRef as ReactComponent };